











































import { Component, Vue } from "vue-property-decorator";
import { ErrorBag, Validator } from "vee-validate";
import EditPageBase from "@/views/Generic/EditPageBase.vue";
import BeraterGruppeApi from "../api/BeraterGruppeAPI";
import BeraterGruppeCreation from "../types/BeraterGruppeCreation";
import { GlobalHelper } from "@/helper/global-helper";

@Component({ components: {  } })
export default class BeraterGruppenCreate extends EditPageBase {
  private service!: BeraterGruppeApi;

  public item: BeraterGruppeCreation = { Name: "" };

  public errors!: ErrorBag;
  public $validator!: Validator;

  public loading = true;

  async created() {
    this.service = new BeraterGruppeApi();
  }

  async mounted() {
    this.loading = false;
  }

  async onSubmit(event: any) {
    try {
      event.preventDefault();
      await this.$validator.validateAll();
      this.disableWatch();
      if (this.errors.count() == 0) {
          await this.service.CreateBeraterGruppe(this.item);
        GlobalHelper.NotifySuccess();
        this.dirty = false;
        this.$router.push({ name: "administration-einstellungen-projektteams" });
      } else {
        GlobalHelper.NotifyError(
          this.$t("Allgemein.Pflichtfeld nicht ausgefüllt.").toString()
        );
      }
    } catch (e) {
      console.log(e);
    }
  }
}
